import { render, staticRenderFns } from "./TabClinicLocation.vue?vue&type=template&id=b12be3de&scoped=true&"
import script from "./TabClinicLocation.vue?vue&type=script&lang=js&"
export * from "./TabClinicLocation.vue?vue&type=script&lang=js&"
import style0 from "./TabClinicLocation.vue?vue&type=style&index=0&id=b12be3de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12be3de",
  null
  
)

export default component.exports